<template>
  <div>
    <div class="mpf-panel">
      <h1 class="mpf-panel__title">{{ panelTitle ?? 'Appointment booked' }}</h1>
      <div class="mpf-panel__body">Your appointment is confirmed.</div>
    </div>

    <MpfSummaryList v-if="summaryRows.length" :rows="summaryRows" />

    <!-- Cancellation is offered inline here, which is why the cancellation store
         is shared rather than owned by the cancellation flow alone. -->
    <p v-if="bookedAppointmentId">
      If you can no longer make it,
      <router-link class="mpf-link" :to="cancellationPath">cancel this appointment</router-link>.
    </p>

    <p v-if="!isOpenInNhsApp">You may now close this window.</p>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { storeToRefs } from 'pinia';

  import MpfSummaryList from '../components/MpfSummaryList/MpfSummaryList.vue';
  import { useAppointmentBookingStore } from '../../stores/useAppointmentBookingStore';
  import { useNhsAppStore } from '../../stores/useNhsAppStore';
  import { useRouteMeta } from '../composables/useRouteMeta';
  import { useAppointmentSummaryRows } from '../composables/useAppointmentSummaryRows';

  const { panelTitle } = useRouteMeta();

  const store = useAppointmentBookingStore();
  const { appointment, bookedAppointmentId } = storeToRefs(store);
  const { summaryRows } = useAppointmentSummaryRows(appointment);

  const cancellationPath = computed(() => `/appointment-cancellation/${bookedAppointmentId.value}`);

  const { isOpenInNhsApp } = storeToRefs(useNhsAppStore());
</script>
